/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_AssigneeInputs */

const cs_calendar_assignee = /** @type {(inputs: Calendar_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiřazeno`)
};

const en_calendar_assignee = /** @type {(inputs: Calendar_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignee`)
};

/**
* | output |
* | --- |
* | "Assignee" |
*
* @param {Calendar_AssigneeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_assignee = /** @type {((inputs?: Calendar_AssigneeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_AssigneeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_assignee(inputs)
	return cs_calendar_assignee(inputs)
});